import "./Footer.css";
import UnityLogo from "../../assets/icons/Path 0.png";
import {
  Facebook,
  Instagram,
  MessageCircle,
  MapPin,
  Phone,
  Copyright,
} from "lucide-react";
import { Link } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const Footerv2 = () => {
  return (
    <div className="footer_v2">
      <div className="footer-container_v2">
        {/* <div className="footer1_v2">
          <div className="subcaption-container_v2">
            <div className="subcaption_v2">
              <span>Join our newsletter</span>
              <br />
              Subscribe to get information, latest news and other
              <br />
              interesting offers about Unity
            </div>
          </div>

          <div className="subscribe-container_v2">
            <div className="subscribe_v2">
              <FontAwesomeIcon icon={faEnvelope} style={{ color: "#798777" }} />
              <input type="text" placeholder="Enter your email address" />
              <button>Subscribe</button>
            </div>
          </div>
        </div> */}

        {/* <div className="footer-line_v2"></div> */}

        <div className="footer2_v2">
          <div className="footerinfo1-container_v2">
            <div className="footerinfo1_v2">
              <FallbackImg
                src={UnityLogo}
                alt="unitylogo"
                style={{ width: "150px", height: "45px" }}
              />
              <div className="footercaption_v2">
                Empowering your choice with
                <br />
                quality and innovation
              </div>
              <div className="address-container_v2">
                <MapPin size={16} className="address-icon_v2" />
                <div className="address_v2">
                  No. 21-3, Jalan Anggun City 1, Pusat Komersial Anggun City,
                  Taman Anggun, 48000 Rawang, Selangor.
                </div>
              </div>
              <div className="phoneno-container_v2">
                <Phone size={16} className="phoneno-icon_v2" />
                <div className="phoneno_v2">017-3750336</div>
              </div>
            </div>
          </div>

          <div className="footerinfo2-container_v2">
            <div className="footerinfo2_v2">
              <ul>
                <li className="footer-subtitle_v2">
                  <strong>Company Info</strong>
                </li>
                <li>
                  <Link to="/aboutus">About Unity</Link>
                </li>
                {/* additional company links can be added here */}
              </ul>
            </div>
          </div>

          <div className="footerinfo3-container_v2">
            <div className="footerinfo3_v2">
              <ul>
                <li className="footer-subtitle_v2">
                  <strong>Help & Support</strong>
                </li>
                <li>
                  <Link to="/brandservicecenter">Repair</Link>
                </li>
                {/* <li>
                  <Link to="/faq">FAQ</Link>
                </li> */}
                <li style={{ opacity: "0.5", cursor: "not-allowed" }}>FAQ</li>
              </ul>
            </div>
          </div>

          <div className="footerinfo4-container_v2">
            <div className="footerinfo4_v2">
              <ul>
                <li className="footer-subtitle_v2">
                  <strong>More</strong>
                </li>
                <li>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/termsconditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/refundreturnpolicy">Refund & Return Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-line_v2"></div>

        <div className="footer-bottom-row_v2">
          <div className="accept_v2">
            <div className="accept-label_v2">
              <strong>We Accept:</strong>
            </div>
            <div className="paymenticons_v2">
              <div className="accept-pill_v2">FPX</div>
              <div className="accept-pill_v2">IBG</div>
            </div>
          </div>

          <div className="follow_v2">
            <div className="follow-label_v2">Follow Us:</div>
            <div className="footer-social_v2">
              <a
                href="https://www.facebook.com/unity.net.malaysia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <Facebook className="social-icon_v2" size={20} />
              </a>
              <a
                href="https://www.instagram.com/unity_malaysia/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram className="social-icon_v2" size={20} />
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=60173750336&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <MessageCircle className="social-icon_v2" size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-line_v2"></div>

        <div className="footer3_v2">
          <Copyright size={16} />
          {new Date().getFullYear()} Unity All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Footerv2;
